import { render } from "./TransportBoxCarCreateEditDialog.vue?vue&type=template&id=50133663&scoped=true&ts=true"
import script from "./TransportBoxCarCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./TransportBoxCarCreateEditDialog.vue?vue&type=script&lang=ts"

import "./TransportBoxCarCreateEditDialog.vue?vue&type=style&index=0&id=50133663&scoped=true&lang=css"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50133663"]])

export default __exports__